import React from 'react';
import { Row, Typography, Avatar } from 'antd';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { Orders } from '../../../store/orders/types';
import _ from 'lodash';
import { getScheduleTime } from '../../userprofile/components/FoodList';
import { useSelector } from 'react-redux';
import { getOrderState } from '../../../store/orders/selector';
import { getUserState } from '../../../store/user/selector';
import { rateGuestModalHandler } from '../cookscomponent/RateGuest';
import { orderAcceptedModalHandler } from './OrderAccepted';
import { orderTimeDifference } from './CurrentOrders';
import i18next from 'i18next';

export interface PastOrderProps {
  meal: Orders;
  isGuest: boolean;
}

export const LastOrders: React.FC<PastOrderProps> = ({ meal, isGuest }) => {
  const { ratings } = useSelector(getOrderState);
  const { user } = useSelector(getUserState);
  const history = useHistory();
  const getFirstSchedule = _.head(meal.schedule);
  const getFirstScheduleTime = _.head(getFirstSchedule?.time);
  const time = getScheduleTime(getFirstScheduleTime);
  const newmealitems = {
    ...meal,
    isOrder: true,
    time,
    isGuest,
  };
  const navigate = () => {
    history.push({
      pathname: '/orderdetails',
      state: {
        ...newmealitems,
      },
    });
  };
  const handleOnClick = () => {
    const isOrderAfterTwoHours = orderTimeDifference(meal.consumptiondate);
    const userhasRatedOrder = ratings.find(
      r => r.ratedby === user.userid && r.order === meal.id
    );

    if (
      meal.status === 'accepted' &&
      isOrderAfterTwoHours &&
      !userhasRatedOrder
    ) {
      rateGuestModalHandler(meal, navigate, isGuest);
      return;
    }

    if (meal.status === 'accepted' && isGuest && !isOrderAfterTwoHours) {
      orderAcceptedModalHandler(meal, navigate);
      return;
    }
    navigate();
  };
  let date;
  const today = moment().format('MM/DD/YYYY');
  const yesterday = moment().subtract(1, 'day');
  const seconds = _.get(meal.timeadded, 'seconds');
  const orderdatetime = moment.unix(seconds);
  const orderedPlaceDate = moment(orderdatetime).format('MM/DD/YYYY');
  if (moment(orderedPlaceDate).isSame(today)) {
    date = i18next.t('TODAY');
  } else if (moment(orderedPlaceDate).isSame(yesterday, 'day')) {
    date = i18next.t('YESTEDAY');
  } else {
    date = 'other';
  }
  return (
    <div onClick={handleOnClick}>
      <Row justify="space-between" className="pastorder-container">
        <Row>
          <Avatar src={meal.userdetails.image} size="small" />
          <Typography.Text className="profile-text" ellipsis>
            {meal.userdetails.firstName}
          </Typography.Text>
        </Row>
        <Typography.Text className="time-text">
          {date !== 'other'
            ? date
            : moment(orderedPlaceDate).format('DD.MM.YYYY')}
        </Typography.Text>
      </Row>
      <Row justify="start" className="body-container">
        <Typography.Text className="body-text">
          {meal.portions}x
        </Typography.Text>
        <Typography.Text className="food-text">{meal.title}</Typography.Text>
        <Typography.Text className="price-text">{`Kč ${meal.mealprice}`}</Typography.Text>
      </Row>
      <div className="separator" />
    </div>
  );
};
